import React from 'react';
import {
  FormControl,
  FormLabel,
  Slider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

export const StyleSettings = ({ backgroundColor, borderRadius, padding, setProp }) => (
  <Accordion>
    <AccordionSummary expandIcon={<ExpandMore />}>
      <Typography variant="subtitle2">Container Styling</Typography>
    </AccordionSummary>
    <AccordionDetails>
      <FormControl fullWidth margin="normal" component="fieldset">
        <FormLabel component="legend">Background Color</FormLabel>
        <input
          type="color"
          value={backgroundColor || '#ffffff'}
          onChange={(e) => setProp(props => props.backgroundColor = e.target.value)}
        />
      </FormControl>

      <FormControl size="small" component="fieldset" fullWidth margin="normal">
        <FormLabel component="legend">Border Radius</FormLabel>
        <Slider
          value={borderRadius || 0}
          step={1}
          min={0}
          max={50}
          valueLabelDisplay="auto"
          onChange={(_, value) => {
            setProp(props => props.borderRadius = value);
          }}
        />
      </FormControl>

      <FormControl size="small" component="fieldset" fullWidth margin="normal">
        <FormLabel component="legend">Padding</FormLabel>
        <Slider
          value={padding || 0}
          step={1}
          min={0}
          max={50}
          valueLabelDisplay="auto"
          onChange={(_, value) => {
            setProp(props => props.padding = value);
          }}
        />
      </FormControl>
    </AccordionDetails>
  </Accordion>
);